import React, { useRef, useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, Text, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import Canvas from '../../canvas'
import { useStoreStore } from '../../../stores/storeInfo'

const Form8850InformationOnline = ({ navigation, route }) => {
    const {
        values,
        userId,
        mode,
        filingdescription,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()
    const store = useStoreStore()


    const { loading, post8850online, modetailsData } = useFormsStore()

    // const canvasRef = useRef(null)
    const [hasDrawn, setHasDrawn] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')






    const data = {
        entityId: personalstore?.personalData?.entityId,
        essUserKey: intializestore.initializeData.userkey,
        essObKey: essUserOnBoardingKey,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        completeOnline: true,
        age: values?.age,
        recievedconditionalcertificate: values?.receivedconditionalcertificate,
        isQualified: values?.is_qualified,
        isVeteranUnemployed6Months: values?.is_veteran_unemployed_6_months,
        isVeteranDisabilityDischargedPastYear: values?.is_veteran_disability_discharged_past_year,
        isVeteranDisabilityUnemployed6Months: values?.is_veteran_disability_unemployed_6_months,
        isFamilyTanfEligible: values?.is_family_tanf_eligible,
        isUnemployed27Weeks: values?.is_unemployed_27_weeks,
        sign: signatureDataURL,
        county: values?.county

    }

    const handlesubmit = async () => {
        const response = await post8850online(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    const dateOfBirth = personalstore?.personalData?.dateOfBirth;

    const formattedDate = dateOfBirth
        ? moment(dateOfBirth, moment.ISO_8601, true).isValid()
            ? moment(dateOfBirth).format("MM/DD/YYYY")
            : ""
        : "";
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'Form 8850 Witholding Taxation '}
                    />
                </View>
            </View>
            <ScrollView>
                <Card style={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: "1.6", fontSize: "11px"
                }}>


                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tr style={{ width: "100 %" }}>
                            <td style={{ borderBottom: "1px solid" }}>
                                <div>
                                    <p>Form 8850</p>
                                    <p>(Rev.March 2016)</p>
                                    <p>Department of Treasury</p>
                                    <p>Internal Revenue Service</p>
                                </div>
                            </td>
                            <td
                                style={{
                                    borderLeft: "1px solid",
                                    borderRight: "1px solid",
                                    borderBottom: "1px solid"
                                }}

                            >
                                <div>
                                    <h4>
                                        Pre-Screening Notice and Certification Request for the Work
                                        Oppurtunity Credit
                                    </h4>
                                    <p>
                                        Information about Form 8850 and its separate instructions is at
                                        www.irs.gov/form8850
                                    </p>
                                </div>
                            </td>
                            <td style={{ borderBottom: "1px solid" }}>
                                <p>OMB No. 1545 -1500</p>
                            </td>
                        </tr>
                    </table>
                    <p>
                        Job applicant:Fill in the lines below and check my boxes that
                        apply.complete only this side.
                    </p>
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <tr
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                            }}
                        >
                            <td style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: "2px" }}>YourName</p>
                                <input type="text" readOnly value={`${personalstore.personalData?.lastName},${personalstore.personalData?.firstName}`} style={{ height: "15px" }} />
                            </td>
                            <td style={{ display: "flex", alignItems: "center" }}>
                                <p>Social Security Number</p>
                                <input type="text" readOnly value={personalstore?.personalData?.ssn} style={{ height: "15px" }} />
                            </td>
                        </tr>
                    </table>
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <tr>
                            <td>
                                <p>
                                    Street address where you live
                                    <span style={{ borderBottom: "1px solid", minWidth: "10px" }}>
                                        {personalstore?.personalData?.addressLine1}
                                        {personalstore?.personalData?.addressLine2
                                            ? `, ${personalstore.personalData.addressLine2}`
                                            : ""}
                                    </span>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    City or town, state, and ZIP code
                                    <span style={{ borderBottom: "1px solid", minWidth: "10px" }}
                                    >{personalstore?.personalData?.city},{personalstore?.personalData?.stateValue},{personalstore?.personalData?.zip}</span>
                                </p>
                            </td>
                        </tr>
                    </table>
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <tr
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between"
                            }} >
                            <td style={{ display: "flex", alignItems: "center" }}>
                                <p style={{ marginRight: "2px" }}>County</p>
                                <input type="text" readOnly value={values?.county} style={{ height: "15px" }} />
                            </td>
                            <td style={{ display: "flex", alignItems: "center" }}>
                                <p>Telephone number</p>
                                <input type="text" readOnly value={personalstore?.personalData?.mainPhoneNumber} style={{ height: "15px" }} />
                            </td>
                        </tr>
                    </table>

                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <tr>
                            <td>
                                <p>
                                    If you are under age 40, enter your date of birth (month, day, year)
                                    <span style={{ borderBottom: "1px solid", minWidth: "10px", fontWeight: "bold" }}
                                    > {values?.age == 1 ? formattedDate : ""}</span>
                                </p>
                            </td>
                        </tr>
                    </table>
                    <hr style={{ width: "100%", border: "1px solid" }} />

                    <span style={{ paddingRight: "2px" }}> 1.
                        <input type="checkbox" checked={values?.receivedconditionalcertificate == 1 ? true : false} /><label
                            htmlFor="1"
                        >Check here if you received a conditional certification from the state
                            workforce agency (SWA) or a participating local agency for the work
                            opportunity credit.</label></span><br />
                    <span style={{ paddingRight: "2px" }}> 2. <input type="checkbox" checked={values?.is_qualified == 1 ? true : false} />
                        Check here if any of the following statements apply to you.</span>
                    <label htmlFor="2"
                    >
                        <ul>
                            <li>
                                I am a member of a family that has received assistance from Temporary
                                Assistance for Needy Families (TANF) for any 9 months during the past
                                18 months
                            </li>
                            <li>
                                I am a veteran and a member of a family that received Supplemental
                                Nutrition Assistance Program (SNAP) benefits (food stamps) for at
                                least a 3-month period during the past 15 months
                            </li>
                            <li>
                                I was referred here by a rehabilitation agency approved by the state,
                                an employment network under the Ticket to Work program, or the
                                Department of Veterans Affairs
                            </li>
                            <li>
                                I am at least age 18 but not age 40 or older and I am a member of a
                                family that:
                                <ol type="a">
                                    <li>
                                        . Received SNAP benefits (food stamps) for the past 6 months; or
                                    </li>
                                    <li>
                                        . Received SNAP benefits (food stamps) for at least 3 of the past
                                        5 months, but is no longer eligible to receive them.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                During the past year, I was convicted of a felony or released from
                                prison for a felony
                            </li>
                            <li>
                                I received supplemental security income (SSI) benefits for any month
                                ending during the past 60 days
                            </li>
                            <li>
                                I am a veteran and I was unemployed for a period or periods totaling
                                at least 4 weeks but less than 6 months during the past year
                            </li>
                        </ul>
                    </label>
                    <span style={{ paddingRight: '2px' }}> 3. <input type="checkbox" checked={values?.is_veteran_unemployed_6_months == 1 ? true : false} /><label
                        htmlFor="3"
                    >Check here if you are a veteran and you were unemployed for a period or
                        periods totaling at least 6 months during the past year. </label
                    ></span><br />

                    <span style={{ paddingRight: '2px' }}> 4.<input type="checkbox" checked={values?.is_veteran_disability_discharged_past_year == 1 ? true : false} /><label
                        htmlFor="4"
                    >Check here if you are a veteran entitled to compensation for a
                        service-connected disability and you were discharged or released from
                        active duty in the U.S. Armed Forces during the past year. </label
                    > </span><br />
                    <span style={{ paddingRight: '2px' }}> 5. <input type="checkbox" checked={values?.is_veteran_disability_unemployed_6_months == 1 ? true : false} /><label
                        htmlFor="5"
                    >Check here if you are a veteran entitled to compensation for a
                        service-connected disability and you were unemployed for a period or
                        periods totaling at least 6 months during the past year </label
                    ></span><br />

                    <span style={{ paddingRight: '2px' }}> 6. <input type="checkbox" checked={values?.is_family_tanf_eligible == 1 ? true : false} />Check here if you are a member of a family that:</span>
                    <label
                        htmlFor="6"
                    >
                        <ul>
                            <li>Received TANF payments for at least the past 18 months; or</li>
                            <li>
                                Received TANF payments for any 18 months beginning after August 5,
                                1997, and the earliest 18-month period beginning after August 5, 1997,
                                ended during the past 2 years; or
                            </li>
                            <li>
                                Stopped being eligible for TANF payments during the past 2 years
                                because federal or state law limited the maximum time those payments
                                could be made
                            </li>
                        </ul> </label><br />



                    <span style={{ paddingRight: '2px' }}> 7. <input type="checkbox" checked={values?.is_unemployed_27_weeks == 1 ? true : false} /><label
                        htmlFor="7"
                    >Check here if you are in a period of unemployment that is at least 27
                        consecutive weeks and for all or part of that period you received
                        unemployment compensation </label></span><br />

                    <hr style={{ border: "1px solid", width: "100%" }} />
                    <p style={{ textAlign: "center", fontWeight: "bold" }}>
                        Signature—All Applicants Must Sign
                    </p>
                    <hr style={{ border: "1px solid", width: "100%" }} />
                    <p>
                        Under penalties of perjury, I declare that I gave the above information to
                        the employer on or before the day I was offered a job, and it is, to the
                        best of my knowledge, true, correct, and complete.
                    </p>

                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            borderBottom: '2px solid #000'
                        }}
                    >
                        <tr>
                            <td style={{ width: '60%', fontSize: '11px' }}>
                                <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} />
                                <br />
                                Employee's Signature
                            </td>
                            <td style={{ width: '40%', fontSize: '11px' }}>
                                Date : {moment().format('MM/DD/YYYY')}
                            </td>
                        </tr>
                    </table>

                    <hr style={{ border: "1px solid", width: "100%" }} />
                    <p style={{ textAlign: "center", fontWeight: "bold" }}>For Employer’s Use Only</p>

                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tr>
                            <td>
                                Employer’s name
                                <input type="text" value={modetailsData?.data?.employersName} readOnly />
                            </td>
                            <td>
                                Telephone no.
                                <input type="text" value={modetailsData?.data?.phoneNumber} readOnly />
                            </td>
                            <td>
                                EIN
                                <input type="text" value={modetailsData?.data?.taxIdentificationNumber} readOnly />
                            </td>
                        </tr>
                    </table>
                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
                        <tr>
                            <td>
                                <span>Street address</span>
                                <input type="text" value={modetailsData?.data?.employerAddress} readOnly />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>City or town, state, and ZIP code</span>
                                <input type="text" value={`${modetailsData?.data?.city} ${modetailsData?.data?.state} ${modetailsData?.data?.zipCode}`} readOnly />
                            </td>
                        </tr>
                    </table>
                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
                        <tr>
                            <td>
                                <span>Person to contact, if different from above</span>
                                <input type="text" value="" readOnly />
                            </td>
                            <td>
                                <span>Telephone no</span>
                                <input type="text" value="" readOnly />
                            </td>
                        </tr>
                    </table>

                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
                        <tr>
                            <td>
                                <span>Street address</span>
                                <input type="text" value="" readOnly />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>City or town, state, and ZIP code</span>
                                <input type="text" value="" readOnly />
                            </td>
                        </tr>
                    </table>
                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
                        <tr>
                            <td>
                                If, based on the individual’s age and home address, he or she is a
                                member of group 4 or 6 (as described under Members of Targeted Groups
                                in the separate instructions), enter that group number (4 or 6)
                            </td>
                            <td>
                                <input type="text" value="" readOnly />
                            </td>
                        </tr>
                    </table>
                    <p>Date Applicant:</p>

                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
                        <tr>
                            <td>

                                <span>Gave information</span>
                                <input type="text" value={moment().format('MM/DD/YYYY')} readOnly />
                            </td>
                            <td>
                                <span>Was offered job</span>
                                <input type="text" value="" readOnly />
                            </td>
                            <td>
                                <span>Was hired</span>
                                <input type="text" value={store?.storeData?.hireDate ? moment(store?.storeData?.hireDate).format('MM/DD/YYYY') : ""} readOnly />
                            </td>
                            <td>
                                <span>Started job</span>
                                <input type="text" value="" readOnly />
                            </td>
                        </tr>
                    </table>

                    <hr style={{ width: "100%", border: "1px solid" }} />

                    <p>
                        Under penalties of perjury, I declare that the applicant provided the
                        information on this form on or before the day a job was offered to the
                        applicant and that the information I have furnished is, to the best of my
                        knowledge, true, correct, and complete. Based on the information the job
                        applicant furnished on page 1, I believe the individual is a member of a
                        targeted group. I hereby request a certification that the individual is a
                        member of a targeted group
                    </p>

                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
                        <tr>
                            <td>
                                <span>Employer’s signature </span>
                            </td>
                            <td><span>Title</span></td>
                            <td><span>Date</span></td>
                        </tr>
                    </table>
                    <hr style={{ width: "100%", border: "1px solid" }} />

                    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
                        <tr style={{ width: "100%" }}>
                            <td style={{ width: "32%" }}>
                                <p style={{ fontWeight: "bold" }}>
                                    Privacy Act and Paperwork Reduction Act Notice
                                </p>

                                Section references are to the Internal Revenue Code. Section 51(d)(13)
                                permits a prospective employer to request the applicant to complete
                                this form and give it to the prospective employer. The information
                                will be used by the employer to complete the employer’s federal tax
                                return. Completion of this form is voluntary and may assist members of
                                targeted groups in securing employment. Routine uses of this form
                                include giving it to the state workforce agency (SWA), which will
                                contact appropriate sources to confirm that the applicant is a member
                                of a targeted group. This form may also be given to the Internal
                                Revenue Service for administration of the Internal Revenue laws, to
                                the Department of Justice for civil and
                            </td>
                            <td style={{ width: "32%" }}>
                                criminal litigation, to the Department of Labor for oversight of the
                                certifications performed by the SWA, and to cities, states, and the
                                District of Columbia for use in administering their tax laws. We may
                                also disclose this information to other countries under a tax treaty,
                                to federal and state agencies to enforce federal nontax criminal laws,
                                or to federal law enforcement and intelligence agencies to combat
                                terrorism. You are not required to provide the information requested
                                on a form that is subject to the Paperwork Reduction Act unless the
                                form displays a valid OMB control number. Books or records relating to
                                a form or its instructions must be retained as long as their contents
                                may become material in the administration of any Internal Revenue law.
                                Generally, tax returns and return information are confidential, as
                                required by section 6103.
                            </td>
                            <td style={{ width: "32%" }}>
                                The time needed to complete and file this form will vary depending on
                                individual circumstances. The estimated average time is: Recordkeeping
                                . . 6 hr., 27 min. Learning about the law or the form . . . . . . . 24
                                min. Preparing and sending this form to the SWA . . . . . . . 31 min.
                                If you have comments concerning the accuracy of these time estimates
                                or suggestions for making this form simpler, we would be happy to hear
                                from you. You can send us comments from www.irs.gov/formspubs. Click
                                on “More Information” and then on “Give us feedback.” Or you can send
                                your comments to: Internal Revenue Service Tax Forms and Publications
                                1111 Constitution Ave. NW, IR-6526 Washington, DC 20224 Do not send
                                this form to this address. Instead, see When and Where To File in the
                                separate instructions.
                            </td>
                        </tr>
                    </table>





                </Card >
                {loading ? <ActivityIndicator /> :
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() =>
                                navigation.navigate('Form8850InformationForm', {
                                    essUserOnBoardingFormKey,
                                    essUserOnBoardingKey
                                })
                            }
                        />
                        <CustomButton


                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>}
            </ScrollView >
        </>
    )
}


export default Form8850InformationOnline
